import React, { useEffect, useState } from "react";
import { jwtDecode } from "jwt-decode";
import dayjs from "dayjs";
import { Box, CircularProgress, Typography } from "@mui/material";
import { alpha, useTheme } from "@mui/material/styles";
import { PedidosVentaApi } from "../../api/PedidosVenta/PedidosVentaApi";
import TablaReducida from "./TablaReducida";

const TablaReducidaPage = () => {
  const theme = useTheme();
  const [resumenRows, setResumenRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [empresa, setEmpresa] = useState("fusion");

  const [year, setYear] = useState(dayjs().year());

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);

        const token = localStorage.getItem("token");
        const decoded = jwtDecode(token);
        const userEmail = decoded.email;
        const isAdmin = decoded.isAdmin;

        const data = await PedidosVentaApi.getPedidosComisionesReducido(
          empresa,
          year
        );

        const filtered = isAdmin
          ? data
          : data.filter(
              (row) =>
                row.E_MAIL?.toLowerCase().trim() ===
                userEmail.toLowerCase().trim()
            );

        setResumenRows(filtered);
      } catch (err) {
        console.error("❌ Error cargando márgenes:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [year, empresa]);

  if (loading) {
    return (
      <Box
        sx={{
          minHeight: "60vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 1.5,
            p: 3,
            borderRadius: 3,
            border: "1px solid",
            borderColor: "divider",
            backgroundColor: alpha(theme.palette.background.paper, 0.85),
            boxShadow: `0 8px 24px ${alpha(
              theme.palette.common.black,
              theme.palette.mode === "dark" ? 0.35 : 0.08,
            )}`,
            minWidth: 220,
          }}
        >
          <CircularProgress size={32} />
          <Typography variant="body2" color="text.secondary" fontWeight={600}>
            Cargando márgenes…
          </Typography>
        </Box>
      </Box>
    );
  }

  return (
    <TablaReducida
      resumenRows={resumenRows}
      year={year}
      setYear={setYear}
      empresa={empresa}
      setEmpresa={setEmpresa}
      loading={loading}
    />
  );
};

export default TablaReducidaPage;
